import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {IntPortalOutletService} from "../../../portal-outlet";
import {IntNotificationsService} from "../../services/int-notifications.service";

@Component({
  selector: 'int-notification-root',
  templateUrl: './notification-root.component.html',
  styleUrls: ['./notification-root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    IntPortalOutletService
  ]
})
export class NotificationRootComponent implements OnInit, AfterViewInit {

  @ViewChild('defaultNotificationTemplate') private readonly defaultNotificationTemplate!: TemplateRef<any>

  templates$ = this.portal.templates$;

  constructor(
    private readonly portal: IntPortalOutletService,
    private readonly service: IntNotificationsService,
  ) {
  }

  ngAfterViewInit() {
    this.service.setTemplate(this.defaultNotificationTemplate);
  }

  ngOnInit(): void {
    this.service.setPortalOutletService(this.portal);
  }
}
